// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import classNames from "classnames"
// MUI
import { withStyles} from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Icon from "@material-ui/core/Icon"
// Other
import { EmailShareButton, WhatsappShareButton } from "react-share"

// Icons
import EmailIconFile from "../static/images/email-circle-2color-blue.svg"
import  WhatsappIconFile from "../static/images/whatsapp-circle-2color-green.svg"
import CloseIcon from "@material-ui/icons/Close"
import grey from "@material-ui/core/colors/grey"

// LOGGING SETUP
import appConfig from "./../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashShare>")

const styles = theme => {
    return {
        messageRoot: {
            position: "fixed",
            top: 0,
            left: 0,
            //            background: "rgba(0,0,0,0.6)",
            background: theme.messageBackground,
            zIndex: 1000,
            width: "100%",
            height: "100%",
            //            display: "none",
            display: "flex",
            justifyContent: "center",
        },
        messagePaper: {
            //            marginTop: "auto",
            //            marginBottom: "auto",
            margin: "auto",
            marginLeft: 20,
            marginRight: 20,
//            padding: 20,
            width: 200,
            height: 100,
            //            display: "flex",
            //            alignItems: "center",
            //            justifyContent: "center",
            //            flexWrap: "wrap",
            //            flexDirection: "column"
        },

        imageIcon: {
            // height: '100%'
            height: 52
        },
        iconRoot: {
            textAlign: 'center'
        }
        
    }
}

class FlashShare extends Component {
    render() {
        const { classes, isVisible, variant, onDone } = this.props
        return (
            <div>

              { isVisible && variant === "summary" && (
                  <div className={classes.messageRoot} onClick={onDone}>
                    <Paper className={classes.messagePaper}>
                      <div style={{width: "100%", textAlign: "right", padding: 5}} ><CloseIcon style={{color: grey[600]}}/></div>

                      <div style={{display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: -5}}>
                      
                        <div>
                          <EmailShareButton url="https://demo.lightning.reviews"
                                            subject="Please support my issue"
                                            body="Let's be heard by our representatives through Lightning: "
                          >
                            <Icon classes={{root: classes.iconRoot}}>
                              <img alt="email-icon" className={classes.imageIcon} src={EmailIconFile}/>
                            </Icon>
                          </EmailShareButton>
                        </div>
                        <div>
                          <WhatsappShareButton
                            url="https://demo.lightning.reviews"
                            title="Please support my issue"
                            separator=" "
                          >
                            <Icon classes={{root: classes.iconRoot}}>
                              <img alt="whatsapp-icon" className={classes.imageIcon} src={WhatsappIconFile}/>
                            </Icon>
                          </WhatsappShareButton>
                        </div>
                      </div>                
                    </Paper>
                  </div>
              )}
              
            </div>
        )
    }
}

FlashShare.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(FlashShare)
